<template>
    <button type="button" class="btn btn-secondary" @click="toggleFormat">
        {{ $trans.get("__JSON__.time format") }}
    </button>
</template>

<script>
export default {
    name: "TimeFormatToggle",

    data() {
        return {
            localIsDecimal: null,
        };
    },
    mounted() {
        const cookie = document.cookie
            .split('; ')
            .find(row => row.startsWith('time_format='));
        this.localIsDecimal = cookie ? cookie.split('=')[1] === 'decimal' : true;
        this.updateTimeDisplay();
    },
    methods: {
        /**
         * Toggle the time format between decimal and hours:minutes.
         */
        toggleFormat() {
            this.localIsDecimal = !this.localIsDecimal;
            this.updateTimeDisplay();
        },

        /**
         * Update every element with the class 'time-format' to display the time in the current format.
         */
        updateTimeDisplay() {
            const timeElements = $(".time-format");

            timeElements.each((index, element) => {
                const timeValue = $(element).data("seconds");
                let formattedTime;

                if (this.localIsDecimal) {
                    formattedTime = (timeValue / 3600).toFixed(2);
                } else {
                    const absValue = Math.abs(timeValue);
                    const hours = Math.floor(absValue / 3600);
                    const minutes = Math.floor((absValue % 3600) / 60);
                    const seconds = absValue % 60;
                    formattedTime = timeValue < 0 ? `-${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}` :
                        `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
                }
                $(element).text(formattedTime);
            });
            document.cookie = `time_format=${this.localIsDecimal ? 'decimal' : 'hours:minutes'}; path=/; max-age=31536000`;
        }
    }
};
</script>

<style scoped></style>